function convertAppPage(documentServices, appData, token, {pageRef}) {
  return documentServices.wixapps.migrate.convertAppPage(pageRef)
}

export default {
  migrate: {
    convertAppPage,
  },
}
